import React from 'react';
import spinnerDark from '../../assets/images/spinner-dark.png';
import spinnerLight from '../../assets/images/spinner-light.png';

const Spinner = ({ variant = 'dark', size = 'h-16 w-16' }) => {
  const spinnerSrc = variant === 'light' ? spinnerLight : spinnerDark;
  
  return (
    <img 
      src={spinnerSrc} 
      alt="Loading..." 
      className={`${size} animate-spin`}
      style={{ animationDuration: '0.8s' }}
    />
  );
};

export default Spinner;
